import { defineComponent as E, ref as D, computed as e, onMounted as $, onBeforeUnmount as O, createElementBlock as v, openBlock as c, mergeProps as h, toHandlers as U, createElementVNode as a, createVNode as j, createBlock as w, createCommentVNode as x, unref as g, resolveDynamicComponent as z, toRaw as H, normalizeClass as I, toDisplayString as u, withCtx as M, createTextVNode as Y } from "vue";
import { RevIllustration as q } from "@ds/components/Illustration";
import { RevLink as F } from "@ds/components/Link";
import G from "../../../icons/generated/IconCheckInCircle.vue2.js";
import J from "../../../icons/generated/IconInfo.vue2.js";
import K from "../../../icons/generated/IconWarning.vue2.js";
import { useI18n as Q } from "@ds/plugin";
import { track as y } from "@ds/tracking/tracking";
import W from "../../../translations/generic.translations.js";
import { tw as i } from "../../../utils/tailwind.js";
import { TOAST_VISIBILITY_DURATION as X, VariantsEnum as n } from "../Toast.constant.js";
const Z = ["aria-live", "role"], p = { class: "flex items-center justify-between gap-20" }, _ = { class: "flex flex-1 items-center" }, tt = {
  key: 1,
  class: "text-static-default-hi"
}, et = { class: "flex-1 py-2" }, it = { class: "text-static-default-mid body-2 w-full min-w-full" }, wt = /* @__PURE__ */ E({
  name: "RevToastItem",
  __name: "ToastItem",
  props: {
    actionLabel: { default: () => {
    } },
    name: {},
    title: {},
    description: { default: () => {
    } },
    variant: { default: () => n.Info },
    iconSrc: { default: "" },
    icon: { default: () => {
    } },
    iconProps: { default: () => ({ alt: "", height: 32, width: 32 }) },
    duration: { default: () => X }
  },
  emits: ["close", "action"],
  setup(t, { emit: b }) {
    const r = b, s = D(null), C = {
      info: "polite",
      success: "polite",
      error: "assertive"
    }, T = e(() => C[t.variant]), N = {
      info: i`bg-static-default-hi mood-inverse`,
      success: i`bg-static-default-hi mood-inverse`,
      error: i`bg-static-danger-hi`
    }, S = e(() => [
      i`shadow-long rounded-lg pointer-events-auto min-w-0 overflow-hidden px-16 py-12 md:min-w-300 md:max-w-400`,
      N[t.variant]
    ]), k = e(() => [
      i`text-static-default-hi body-1`,
      t.description && i`body-1-bold`
    ]), m = i`mr-16 h-32 max-w-32`, L = {
      info: "status",
      success: "status",
      error: "alert"
    }, V = e(() => L[t.variant]), d = e(() => {
      if (t.variant === n.Success)
        return G;
      if (t.variant === n.Error)
        return K;
      if (t.variant === n.Info && !t.iconSrc)
        return t.icon || J;
    }), f = e(() => t.variant === n.Info && t.iconSrc ? t.iconSrc : "");
    function o() {
      s.value !== null && window.clearTimeout(s.value), s.value = null;
    }
    function P() {
      r("action"), r("close"), o();
    }
    function R() {
      r("close"), o();
    }
    function l() {
      o(), s.value = window.setTimeout(R, t.duration);
    }
    $(() => {
      l(), y({
        action: "toast",
        context: {
          name: t.name,
          status: "opened"
        }
      });
    }), O(() => {
      o(), y({
        action: "toast",
        context: {
          name: t.name,
          status: "closed"
        }
      });
    });
    const B = Q(), A = e(
      () => t.actionLabel || B(W.buttonClose)
    );
    return (ot, at) => (c(), v("div", h({
      "aria-atomic": "true",
      "aria-live": T.value,
      class: S.value,
      role: V.value
    }, U({
      focusin: o,
      focusout: l,
      mouseleave: l,
      mouseover: o
    }, !0)), [
      a("div", p, [
        a("div", _, [
          f.value ? (c(), w(g(q), h({ key: 0 }, t.iconProps, {
            alt: t.iconProps.alt,
            class: m,
            height: t.iconProps.height,
            src: f.value,
            width: t.iconProps.width
          }), null, 16, ["alt", "height", "src", "width"])) : x("", !0),
          d.value ? (c(), v("div", tt, [
            (c(), w(z(H(d.value)), {
              class: I(m)
            }))
          ])) : x("", !0),
          a("div", et, [
            a("span", {
              class: I(k.value)
            }, u(t.title), 3),
            a("div", it, u(t.description), 1)
          ])
        ]),
        j(g(F), {
          underlined: !1,
          onClick: P
        }, {
          default: M(() => [
            Y(u(A.value), 1)
          ]),
          _: 1
        })
      ])
    ], 16, Z));
  }
});
export {
  wt as default
};
